export enum ColumnFieldType {
  // eslint-disable-next-line id-denylist,id-blacklist
  String = 'String',
  HyperLink = 'HyperLink',
  Date = 'Date',
  // eslint-disable-next-line id-denylist,id-blacklist
  Number = 'Number',
  Dropdown = 'Dropdown',
  Html = 'Html',
  TimeFrame = 'TimeFrame',
  Checkbox = 'Checkbox',
  ActionIcons = 'ActionIcons',
  FindControl = 'FindControl',
  RadioButton = 'RadioButton',
  ExtTimeframe = 'ExtTimeframe',
  ExtFindcontrol = 'ExtFindcontrol',
  DateTime = 'DateTime',
}
